import ConstructiveFeedbackCommunication from '~/pages/communication/constructiveFeedback/libs/components/ConstructiveFeedbackCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const ConstructiveFeedbackCommunicationPage = (props: TPageProps) => (
  <ConstructiveFeedbackCommunication {...props} />
)

export default ConstructiveFeedbackCommunicationPage
